import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

const ConditionalLink = ({ href, to, title, children, ...extraProps }) => {
    const isMobile = true // useMemo(() => window.innerWidth <= 991, []);
    // Use the provided `href` or `to` for URLs
    const linkHref = href || to;

    if (isMobile) {
        return (
            <a href={linkHref} {...extraProps}>
                {children}
            </a>
        );
    }

    return (
        <Link to={linkHref} {...extraProps}>
            {children}
        </Link>
    );
};

export default ConditionalLink;